import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { teamActions } from "@fitness-app/app-store";

import NotFound from "~/components/NotFound/NotFound";
import { useAppDispatch } from "~/store/initializeStore";
import HelpArticlePage from "./HelpArticlePage";
import HelpCenter from "./HelpCenter";

const HelpCenterRouter = () => {
  const dispatch = useAppDispatch();

  // Tagi klientek (trainer_config.traineeTags) do zawężenia ogłoszenia. Bez tego
  // lista w oknie publikacji była pusta, dopóki redakcja nie weszła wcześniej do
  // modułu, który ładuje konfigurację sam — tak jak robią to pozostałe routery.
  useEffect(() => {
    void dispatch(teamActions.fetchTrainerConfig());
  }, [dispatch]);

  return (
    <Routes>
      <Route index element={<HelpCenter />} />
      {/* Redakcja materiału ma własny adres — instrukcja z krokami, obrazami
          i filmem nie mieści się w szufladzie obok listy. */}
      <Route path="/nowy" element={<HelpArticlePage />} />
      <Route path="/:id" element={<HelpArticlePage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default HelpCenterRouter;
